import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Figures from "../../form/Figures";
import TypeTextEditor from "../../form/TypeTextEditor";
import CheckBox from "../../form/CheckBox";
import UrlField from '../../form/UrlField';
import DateTimeInput from '../../form/DateTimeInput';

class MagazineForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-1">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-5">
                        <TextInput name="title" value={this.props.values.title} label="Cím" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("title")}/>
                    </div>
                    <div className="col-md-4">
                        <DateTimeInput name="publish_date" showTime={false} value={this.props.values.publish_date} label="Kiadás dátuma" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("publish_date")}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox {...this.props.getFieldProps("published")} name="published" value={this.props.values.published} label="Publikus" saveChanges={this.props.setFieldValue}/>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor name="description" label="Leírás" data={this.props.values} componentConfig={this.props.componentConfig} getFieldProps={this.props.getFieldProps} setFieldValue={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <UrlField {...this.props}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="figures" label="Képek" componentConfig={this.props.componentConfig} data={this.props.values} />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(MagazineForm);
